import axios from "axios";

export const config = {
  appUrl: "/",
}

export const axiosInstance = axios.create({

  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': '*'
  },
});


